import React from 'react';
import AgentDashboard from '../components/dashboard/AgentDashboard';

const AgentDashboardPage = () => {
  return (
    <div className="agent-dashboard-page">
      <AgentDashboard />
    </div>
  );
};

export default AgentDashboardPage;